import { render } from "./RedirectButtonComponent.vue?vue&type=template&id=c70220ce&scoped=true"
import script from "./RedirectButtonComponent.vue?vue&type=script&lang=js"
export * from "./RedirectButtonComponent.vue?vue&type=script&lang=js"

import "./RedirectButtonComponent.vue?vue&type=style&index=0&id=c70220ce&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c70220ce"]])

export default __exports__